
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kebab",
      function () {
        return require("private-next-pages/kebab.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kebab"])
      });
    }
  